import { Check, X } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { Badge } from '@fortem-monorepo/react-ui'

import { useUserContext } from '@/index'

export interface DeveloperFormValuesProps {}

export const FormValues: React.FC<DeveloperFormValuesProps> = ({}) => {
  const {
    watch,
    formState: { isValid },
  } = useFormContext()

  const { isDeveloper } = useUserContext()

  const values = watch()

  if (!isDeveloper()) return null

  return (
    <div className="bg-white border rounded-md p-4 space-y-2">
      <Badge variant={'secondary'}>
        {isValid ? (
          <>
            <Check className={'text-green-500'} /> Valid
          </>
        ) : (
          <>
            <X className={'text-red-500'} /> Invalid
          </>
        )}
      </Badge>
      <pre className={'text-xs'}>{JSON.stringify(values, null, 2)}</pre>
    </div>
  )
}
